import React from "react";
import BaseLayout from "./src/layouts/base-layout";
import "./src/layouts/grid.css";
import "./src/global/styles.scss";

export const wrapPageElement = ({ element, props }) => {
  return <BaseLayout {...props}>{element}</BaseLayout>;
};
